module.exports = __webpack_public_path__ + "img/france.a7f628aa.png";